import { getProductPrice } from '@/utils/utils';
import { sopClient } from '@barracuda/shared';
import { useEffect, useState } from 'react';

const PRODUCT_CODE = 'ODSY_TEST';

type ProductPrice = {
  price: number;
  currencySymbol: string;
};

const formatPublicPrice = ({ currencySymbol, price }: ProductPrice) =>
  `${currencySymbol}${new Intl.NumberFormat().format(price)}`;

export const usePublicProductPrice = (countryCode: string | undefined) => {
  const [publicPrice, setPublicPrice] = useState<string>(() => getProductPrice());

  useEffect(() => {
    async function getPrice(countryCode: string) {
      try {
        const productPrice: ProductPrice = await sopClient.getProductPrice(
          PRODUCT_CODE,
          countryCode
        );
        setPublicPrice(formatPublicPrice(productPrice));
      } catch (e) {
        //do nothing
      }
    }

    if (countryCode) {
      getPrice(countryCode);
    }
  }, [countryCode]);

  return { publicPrice };
};
